
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jpeg-to-tiff-converter",
      function () {
        return require("private-next-pages/jpeg-to-tiff-converter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jpeg-to-tiff-converter"])
      });
    }
  